














import {Component, Prop, Vue} from "vue-property-decorator";

import CopyClickWrapper from "@/views/components/CopyClickWrapper.vue";
import {IActiveShipment} from "@/models/StoreModels";
import {ACTIVE_SHIPMENT_TYPE} from "@/constants/orders";
import {namespace} from "vuex-class";
import {ShipmentLogic} from "@/models/ShipmentLogic";
import ShowOneHub from '@/views/components/Home/dropup/ShowOneHub.vue';
import VueI18n from "vue-i18n";
import {HISTORY, OTHER_ROUTES} from "@/constants/routes";
import LocaleMessage = VueI18n.LocaleMessage;
import {formatPhoneNumberWithSpaces} from "@/helpers/PhoneHelper";

const activeShipments = namespace('activeShipments');
const userDataModule = namespace('userData');

@Component({
  name: "UserPhoneDataPair",
  components: {
    CopyClickWrapper,
    ShowOneHub,
  },
})
export default class UserPhoneDataPair extends Vue {

  @userDataModule.Getter('getId')
  private userId!: number;

  @Prop()
  private shipment!: IActiveShipment;

  private get getSenderOrRecipient(): string {
    return ShipmentLogic.userIsSender(this.shipment, this.userId) ?
        this.$t("dialogShipmentInfo.recipient") as string :
        this.$t("dialogShipmentInfo.sender") as string;
  }

  private get getSenderOrRecipientPhone(): string {
    return ShipmentLogic.userIsSender(this.shipment, this.userId)
        ? this.shipment.to_user_phone
        : this.shipment.from_user_phone;
  }

  private get isCrosstown(): boolean {
    return this.shipment.type === ACTIVE_SHIPMENT_TYPE.TYPE_CROSSTOWN_DELIVERY;
  }

  private get getSenderOrRecipientPhoneFormatted(): string {
    return formatPhoneNumberWithSpaces(this.getSenderOrRecipientPhone);
  }


}
